import React, { useEffect, useState } from "react";
import styles from "../styles/blogs.module.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Link from "next/link";
import { useRouter } from "next/router";
import format from "date-fns/format";
import CustomImage from "./CustomImage";
import { formatOrder, sliderSpeed } from "../utils/constants";
const Blogs: React.FC = () => {
  const router = useRouter();
  const [blogsDetails, setBlogsDetails] = useState<any>([]);
  const [successStoriesDetails, setSuccessStoriesDetails] = useState<any>([]);
  const [coursesDetails, setCoursesDetails] = useState<any>([]);

  const blogsApiData = async () => {
    try {
      const popularBlogsApiData = await (
        await fetch(
          `${process.env.NEXT_PUBLIC_API_BASE_URL}/blogs?_sort=date:DESC&stu_dest_categories.category_ncontains=News&_limit=1&coachingCategory_null=true&successStoriesCategory_null=true`,
        )
      ).json();
      setBlogsDetails(popularBlogsApiData[0]);
    } catch (error) {}
  };

  const successStoriesApiData = async () => {
    try {
      const popularBlogsApiData = await (
        await fetch(
          `${process.env.NEXT_PUBLIC_API_BASE_URL}/blogs?_sort=date:DESC&stu_dest_categories.category_ncontains=News&_limit=1&successStoriesCategory_null=false`,
        )
      ).json();
      setSuccessStoriesDetails(popularBlogsApiData[0]);
    } catch (error) {}
  };

  const coursesApiData = async () => {
    try {
      const popularBlogsApiData = await (
        await fetch(
          `${process.env.NEXT_PUBLIC_API_BASE_URL}/blogs?_sort=date:DESC&stu_dest_categories.category_ncontains=News&_limit=1&successStoriesCategory_null=true&coachingCategory_null=false`,
        )
      ).json();
      setCoursesDetails(popularBlogsApiData[0]);
    } catch (error) {}
  };

  useEffect(() => {
    const loadData = async () => {
      Promise.all([blogsApiData(), successStoriesApiData(), coursesApiData()]);
    };
    loadData();
  }, []);

  const settings = {
    infinite: true,
    speed: sliderSpeed.desktopSpeed,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: sliderSpeed.desktopAutoplaySpeed,
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
  };

  const pathCondition = router.pathname.includes("/blogs");
  return (
    <>
      <div id="featured-blogs" className={styles.blogsMainDiv}>
        <h2 className="text-center">{`${pathCondition ? "Featured " : ""}Blogs`}</h2>
        {/* Desktop view */}
        <div className="d-none d-md-block">
          <Container>
            <div className={styles.main_webinar_event_div}>
              <Row className={styles.flexGap}>
                {blogsDetails && (
                  <Col>
                    <a href={`/blogs/${blogsDetails.slug}`}>
                      <Card className={styles.webCard}>
                        <div id="blogImg" className={styles.event_Card_img}>
                          <CustomImage
                            src={blogsDetails?.newimageUrl?.imageUrl || blogsDetails?.imageUrl || "/"}
                            alt={blogsDetails?.newimageUrl?.alt || ""}
                            layout="responsive"
                            width={570}
                            height={250}
                          />
                        </div>
                        <Card.Body id="blogtxt" className={styles.card_body}>
                          {blogsDetails.category && <h6 className={styles.blogCategories}>{blogsDetails.category}</h6>}
                          <Card.Title className={styles.main_title}>{blogsDetails.title}</Card.Title>
                          <div className={styles.date}>
                            <span>{blogsDetails.date && format(new Date(blogsDetails.date), formatOrder)}</span>
                          </div>
                        </Card.Body>
                      </Card>
                    </a>
                  </Col>
                )}
                <Col>
                  {successStoriesDetails && (
                    <a href={`/blogs/${successStoriesDetails.slug}`}>
                      <Card className={styles.event__webinar_card}>
                        <div id="blogImgs" className={styles.event_Card_img}>
                          <CustomImage
                            src={successStoriesDetails?.newCardImageUrl?.imageUrl || successStoriesDetails?.imageUrl || "/"}
                            alt={successStoriesDetails?.newCardImageUrl?.alt || ""}
                            height={235}
                            width={195}
                          />
                        </div>
                        <Card.Body id="blogtxts" className={styles.card_body}>
                          {successStoriesDetails.category && <h6 className={styles.blogCategories}>{successStoriesDetails.category}</h6>}
                          <Card.Title className={styles.main_title}>{successStoriesDetails.title}</Card.Title>
                          <div className={styles.date}>
                            {" "}
                            <span>{successStoriesDetails.date && format(new Date(successStoriesDetails.date), formatOrder)}</span>
                          </div>
                        </Card.Body>
                      </Card>
                    </a>
                  )}
                  {coursesDetails && (
                    <a href={`/blogs/${coursesDetails.slug}`}>
                      <Card className={styles.event__webinar_card}>
                        <div id="blogImges" className={styles.event_Card_img}>
                          <CustomImage
                            src={coursesDetails?.newCardImageUrl?.imageUrl || coursesDetails?.imageUrl || "/"}
                            alt={coursesDetails?.newCardImageUrl?.alt || ""}
                            height={235}
                            width={195}
                          />
                        </div>
                        <Card.Body id="blogtexts" className={styles.card_body}>
                          {coursesDetails.category && <h6 className={styles.blogCategories}>{coursesDetails.category}</h6>}
                          <Card.Title className={styles.main_title}>{coursesDetails.title}</Card.Title>
                          <div className={styles.date}>
                            <span>{coursesDetails.date && format(new Date(coursesDetails.date), formatOrder)}</span>
                          </div>
                        </Card.Body>
                      </Card>
                    </a>
                  )}
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        {/* mobile view */}
        <div id="featuredblog" className="d-block d-md-none">
          <Container>
            <Row>
              <Col>
                <div className={styles.main_webinar_event_div}>
                  <Slider {...settings}>
                    {blogsDetails && (
                      <div className={styles.mobileBlog}>
                        <a href={`/blogs/${blogsDetails.slug}`}>
                          <Card className={styles.webCard}>
                            <div className={styles.event_Card_img}>
                              <CustomImage
                                src={blogsDetails?.newimageUrl?.imageUrl || blogsDetails?.imageUrl || "/"}
                                alt={blogsDetails?.newimageUrl?.alt}
                                layout="responsive"
                                width={300}
                                height={200}
                              />
                            </div>
                            <Card.Body className={styles.card_body}>
                              {blogsDetails.category && <h6 className={styles.blogCategories}>{blogsDetails.category}</h6>}
                              <Card.Title className={styles.main_title}>{blogsDetails.title}</Card.Title>
                              <div className={styles.date}>
                                <span>{blogsDetails.date && format(new Date(blogsDetails.date), formatOrder)}</span>{" "}
                              </div>
                            </Card.Body>
                          </Card>
                        </a>
                      </div>
                    )}
                    {successStoriesDetails && (
                      <div>
                        <a href={`/blogs/${successStoriesDetails.slug}`}>
                          <Card className={styles.webCard}>
                            <div className={styles.event_Card_img}>
                              <CustomImage
                                src={successStoriesDetails?.newimageUrl?.imageUrl || successStoriesDetails?.imageUrl || "/"}
                                alt={successStoriesDetails?.newimageUrl?.alt || ""}
                                layout="responsive"
                                width={300}
                                height={200}
                              />
                            </div>
                            <Card.Body className={styles.card_body}>
                              {successStoriesDetails.category && <h6 className={styles.blogCategories}>{successStoriesDetails.category}</h6>}
                              <Card.Title className={styles.main_title}>{successStoriesDetails.title}</Card.Title>
                              <div className={styles.date}>
                                <span>{successStoriesDetails.date && format(new Date(successStoriesDetails.date), formatOrder)}</span>
                              </div>
                            </Card.Body>
                          </Card>
                        </a>
                      </div>
                    )}
                    {coursesDetails && (
                      <div>
                        <a href={`/blogs/${coursesDetails.slug}`}>
                          <Card className={styles.webCard}>
                            <div className={styles.event_Card_img}>
                              <CustomImage
                                src={coursesDetails?.newimageUrl?.imageUrl || coursesDetails?.imageUrl || "/"}
                                alt={coursesDetails?.newimageUrl?.alt || ""}
                                layout="responsive"
                                width={300}
                                height={200}
                              />
                            </div>
                            <Card.Body className={styles.card_body}>
                              {coursesDetails.category && <h6 className={styles.blogCategories}>{coursesDetails.category}</h6>}
                              <Card.Title className={styles.main_title}>{coursesDetails.title}</Card.Title>
                              <div className={styles.date}>
                                {" "}
                                <span>{coursesDetails.date && format(new Date(coursesDetails.date), formatOrder)}</span>
                              </div>
                            </Card.Body>
                          </Card>
                        </a>
                      </div>
                    )}
                  </Slider>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        {router.pathname !== "/blogs" && (
          <Container>
            <Row className="text-center mt-4">
              <Col>
                <Link href="/blogs">
                  <a id="moreall-blogs" className={styles.viewMore}>
                    {" "}
                    All Blogs{" "}
                  </a>
                </Link>
              </Col>
            </Row>
          </Container>
        )}
      </div>
    </>
  );
};
export default Blogs;
